import React, { useEffect } from "react";
import {  Redirect } from "react-router";
import { Route, Switch } from "react-router-dom";

import { LoginForm } from "../auth/LoginForm.jsx";
import { RegisterForm } from "../auth/RegisterForm.jsx";
import { ResetRequestForm } from "../auth/ResetRequestForm.jsx";
import { ResetForm } from "../auth/ResetForm.jsx";

export const FullPageFrame = () => {

    useEffect(
        () => {
            document.body.classList.add("fullpage");
            return () => { document.body.classList.remove("fullpage"); }
        }
    )
    return <div className="modal-frame">
        <Switch>
            <Route path="/login" component={LoginForm} />
            <Route path="/register" component={RegisterForm} />
            <Route exact path="/resetpass" component={ResetRequestForm} />
            <Route path="/resetpass/:token" component={ResetForm} />
            <Route render={() => <Redirect to="/login" />} />
        </Switch>
    </div>
    ;
}